import { BaseMimeType, BaseFileExtension } from '../enums/base-available-file-type.enum';

export const BaseFileTypes = [BaseMimeType.pdf, BaseMimeType.jpeg, BaseMimeType.png];
export const AllowedMimeTypes: ReadonlySet<string> = new Set([BaseMimeType.pdf, BaseMimeType.jpeg, BaseMimeType.png]);
export const EXTENSION_TO_MIME: Record<BaseFileExtension, BaseMimeType> = {
  [BaseFileExtension.pdf]: BaseMimeType.pdf,
  [BaseFileExtension.png]: BaseMimeType.png,
  [BaseFileExtension.jpg]: BaseMimeType.jpeg,
  [BaseFileExtension.jpeg]: BaseMimeType.jpeg,
  [BaseFileExtension.csv]: BaseMimeType.csv,
  [BaseFileExtension.zip]: BaseMimeType.zip,
  [BaseFileExtension.xlsx]: BaseMimeType.xlsx,
};
